import { TWorkspaceEntity } from '../types';

/**
 * Built from the whole catalogue, not from the options on display: a selected workspace the
 * dropdown does not show - one arriving by URL, or one no longer active in the range - must
 * still bring its client into the filter.
 */
export function workspaceClientMap(catalogue: TWorkspaceEntity[]): Record<string, string> {
  return Object.fromEntries(catalogue.map(({ id, client_id }) => [id, client_id]));
}
